/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { DocumentDto } from '../models/document-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des documents
 */
@Injectable({
  providedIn: 'root',
})
export class DocumentsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation documentGetList
   */
  static readonly DocumentGetListPath = '/api/documents/list';

  /**
   * Renvoie la liste des documents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<DocumentDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DocumentDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des documents.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `documentGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetList(params?: {
  }): Observable<Array<DocumentDto>> {

    return this.documentGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DocumentDto>>) => r.body as Array<DocumentDto>)
    );
  }

  /**
   * Path part for operation documentLoadList
   */
  static readonly DocumentLoadListPath = '/api/documents/load-list';

  /**
   * Renvoie la liste des documents (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des documents (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `documentLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.documentLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation documentGet
   */
  static readonly DocumentGetPath = '/api/documents/{id}';

  /**
   * Renvoie le document spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGet$Response(params: {

    /**
     * Identifiant du document
     */
    id: number;
  }): Observable<StrictHttpResponse<DocumentDto>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DocumentDto>;
      })
    );
  }

  /**
   * Renvoie le document spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `documentGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGet(params: {

    /**
     * Identifiant du document
     */
    id: number;
  }): Observable<DocumentDto> {

    return this.documentGet$Response(params).pipe(
      map((r: StrictHttpResponse<DocumentDto>) => r.body as DocumentDto)
    );
  }

  /**
   * Path part for operation documentPut
   */
  static readonly DocumentPutPath = '/api/documents/{id}';

  /**
   * Met à jour le document spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentPut$Response(params: {

    /**
     * Identifiant du document à mettre à jour
     */
    id: number;

    /**
     * Document
     */
    body: DocumentDto
  }): Observable<StrictHttpResponse<DocumentDto>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DocumentDto>;
      })
    );
  }

  /**
   * Met à jour le document spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `documentPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentPut(params: {

    /**
     * Identifiant du document à mettre à jour
     */
    id: number;

    /**
     * Document
     */
    body: DocumentDto
  }): Observable<DocumentDto> {

    return this.documentPut$Response(params).pipe(
      map((r: StrictHttpResponse<DocumentDto>) => r.body as DocumentDto)
    );
  }

  /**
   * Path part for operation documentDelete
   */
  static readonly DocumentDeletePath = '/api/documents/{id}';

  /**
   * Supprime le document spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentDelete$Response(params: {

    /**
     * Identifiant du document à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le document spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `documentDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentDelete(params: {

    /**
     * Identifiant du document à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.documentDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation documentPost
   */
  static readonly DocumentPostPath = '/api/documents';

  /**
   * Crée le document spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentPost$Response(params: {

    /**
     * Document
     */
    body: DocumentDto
  }): Observable<StrictHttpResponse<DocumentDto>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DocumentDto>;
      })
    );
  }

  /**
   * Crée le document spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `documentPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentPost(params: {

    /**
     * Document
     */
    body: DocumentDto
  }): Observable<DocumentDto> {

    return this.documentPost$Response(params).pipe(
      map((r: StrictHttpResponse<DocumentDto>) => r.body as DocumentDto)
    );
  }

}
